import { createSelector } from '@reduxjs/toolkit';
const selectRecallAI = (state) => state.recallAI;
export const selectRecallAIStatus = createSelector([selectRecallAI], (recallAI) => recallAI.recallAIStatus);
export const selectRecallAIError = createSelector([selectRecallAI], (recallAI) => recallAI.errorMessage);
export const selectRecallAIService = createSelector([selectRecallAI], (recallAI) => recallAI.service);
export const selectRecallAIManager = createSelector([selectRecallAI], (recallAI) => recallAI.recallAIManager);
